import { getAnswerValue } from './answer-helpers';

const CONCERN_QUESTION_ID = 9021;
const EXISTING_MEMORIES_QUESTION_ID = 9020;
const WRITING_STATUS_QUESTION_ID = 9024;
const KEPT_FOR_QUESTION_ID = 9023;

const CONCERN_LABEL_MAP = {
    1: 'Stories fading',
    2: 'Getting it down'
};

const EXISTING_MEMORIES_LABEL_MAP = {
    1: 'A few photos',
    2: 'Some papers and letters',
    3: 'Something I’ve written',
    4: 'Almost nothing'
};

const WRITING_STATUS_LABEL_MAP = {
    1: 'I’ve started more than once',
    2: 'I started once',
    3: 'I keep meaning to'
};

const KEPT_FOR_LABEL_MAP = {
    1: 'My children',
    2: 'My grandchildren',
    3: 'My nieces and nephews',
    4: 'My husband or wife',
    5: 'Someone who hasn’t been born yet',
    6: 'Just myself'
};

function getConcernLabel(userResponses) {
    return getAnswerValue(userResponses, CONCERN_QUESTION_ID, CONCERN_LABEL_MAP);
}

function getExistingMemoriesLabel(userResponses, isAgeBranch = false) {
    return getAnswerValue(userResponses, EXISTING_MEMORIES_QUESTION_ID, isAgeBranch ? null : EXISTING_MEMORIES_LABEL_MAP);
}

function getWritingStatusLabel(userResponses) {
    return getAnswerValue(userResponses, WRITING_STATUS_QUESTION_ID, WRITING_STATUS_LABEL_MAP);
}

function getKeptForLabel(userResponses, isAgeBranch = false) {
    return getAnswerValue(userResponses, KEPT_FOR_QUESTION_ID, isAgeBranch ? null : KEPT_FOR_LABEL_MAP);
}

export {
    getConcernLabel,
    getExistingMemoriesLabel,
    getWritingStatusLabel,
    getKeptForLabel
};
